import axios from "axios";
import GetServerAddress from "../../../../../functions/GetServerAddress";

export function Find_Next_Awaiting_SEF(logout) {
  const postData = async () => {
    try {
      const response = await axios.post(
        GetServerAddress() + "api/staff/Find_Next_Awaiting_SEF",
        {
          staffAssignEmail: localStorage.getItem("Username"),
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`, // Include the JWT token in the request headers
            username: localStorage.getItem("Username"),
            activitylog: "No",
            aboutid: "Anonymous",
          },
        }
      );
      // Check for specific server response indicating an invalid auth token
      if (response.data.status === 403 || response.data.status === 401) {
        logout();
        return; // Stop further execution in case of invalid auth token
      }
      // Alert for successful POST request
      //console.log("Found:", response.data.data[0]._id);
      console.log("response.data");
      console.log(response.data);
      if (
        response.data &&
        response.data.data &&
        response.data.data.length > 0 &&
        response.data.data[0] &&
        response.data.data[0]._id
      ) {
        //Change page to the next SEF
        window.location.href =
          "/Staff/ViewSEFReview/" + response.data.data[0]._id;
      } else {
        window.alert("No New Availible SEFs found");
      }
    } catch (error) {
      console.error("Error Posting data: ", error);
      // Alert for failed POST request
      window.alert(
        "Error Posting data, please speak to Admin if this issue persists: ",
        error
      );
    }
  };
  postData();
} // Empty dependency array means this effect runs only once
